export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'color-schemes',
    name: '配色方案',
    description: '精选女性网站配色组合，从柔和粉色到高级大地色，为不同风格的美女品牌提供灵感。',
    icon: 'ri-palette-line',
    articleCount: 5,
  },
  {
    slug: 'design-tips',
    name: '设计技巧',
    description: '实用的视觉设计方法论，涵盖色彩对比、视觉层次、留白运用等核心技巧。',
    icon: 'ri-brush-line',
    articleCount: 4,
  },
  {
    slug: 'case-studies',
    name: '案例分析',
    description: '拆解国内外优秀的女性品牌网站，深入分析其色彩策略与视觉体系。',
    icon: 'ri-file-search-line',
    articleCount: 4,
  },
  {
    slug: 'industry-trends',
    name: '行业趋势',
    description: '追踪女性消费市场与设计行业的前沿动态，把握审美演变方向。',
    icon: 'ri-line-chart-line',
    articleCount: 3,
  },
  {
    slug: 'tools-resources',
    name: '工具资源',
    description: '推荐好用的配色工具、色板生成器与设计资源，提升工作效率。',
    icon: 'ri-tools-line',
    articleCount: 3,
  },
];